(function () {
    'use strict';

    Directives.CancelMembershipDirective = function CancelMembershipDirective() {

        // @ngInject
        function CancelMembershipDirectiveControllerCtor($scope, $injector, _, UsersManager, AccountsManager) {
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'CancelMembershipDirectiveController';
            this._ = _;
            this.user = UsersManager.getCurrUser();
            this.AccountsManager = AccountsManager;

            this._init();

            // a flag indicating if multi select is enabled
            this.isEnableMultiSelect = false;
        }

        var CancelMembershipDirectiveController = Class(Controllers.BaseController, {
            constructor: CancelMembershipDirectiveControllerCtor,

            _init: function _init() {

                this.cancellationView = {
                    step_poll : true,
                    step_offer : false,
                    step_feedback : false,
                    step_cancel_confirmation : false,
                    step_pause: false,
                    step_pause_confirmation: false,
                };

                this.reasons = [
                    {key: 'cost', selected: false, title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.REASONS._COST_'},
                    {key: 'missingFeatures', selected: false, title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.REASONS._MISSING_FEATURES_'},
                    {key: 'shuttingDown', selected: false, title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.REASONS._SHUTTING_DOWN_'},
                    {key: 'onlinePayments', selected: false, title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.REASONS._ONLINE_PAYMENTS_'},
                    {key: 'changingPlatform', selected: false, title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.REASONS._CHANGING_PLATFORM_'},
                    {key: 'difficultForMe', selected: false, title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.REASONS._DIFFICULT_FOR_ME_'},
                    {key: 'difficultForClients', selected: false, title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.REASONS._DIFFICULT_FOR_CLIENTS_'},
                    {key: 'transactionFees', selected: false, title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.REASONS._TRANSACTION_FEES_'},
                    {key: 'covid19', selected: false, title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.REASONS._COVID_19_'}
                ];

                this.suggestion = {
                    cost: {
                        title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_7._TITLE_',
                        subTitle: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_7._SUB_TITLE_',
                        cta: '',
                        ctaLink: '',
                    },
                    shuttingDown: {
                        title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_2._TITLE_',
                        subTitle: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_2._SUB_TITLE_',
                        cta: '',
                        ctaLink: '',
                    },
                    onlinePayments: {
                        title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_1._TITLE_',
                        subTitle: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_1._SUB_TITLE_',
                        cta: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_1._LINK_TEXT_',
                        ctaLink: 'https://www.honeybook.com/risingtide/invoice/',
                    },
                    difficultForMe: {
                        title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_4._TITLE_',
                        subTitle: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_4._SUB_TITLE_',
                        cta: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_4._LINK_TEXT_',
                        ctaLink: 'https://help.honeybook.com/',
                    },
                    difficultForClients: {
                        title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_3._TITLE_',
                        subTitle: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_3._SUB_TITLE_',
                        cta: 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_3._LINK_TEXT_',
                        ctaLink: 'https://intercom.help/honeybook-5891e2a409ff/client-experience',
                    }
                };


                this.reasons = this._.shuffle(this.reasons);
                this.otherReason = {key: 'other', selected: false, title: 'SETTINGS.SUBSCRIPTION.CANCELLATION.REASONS._OTHER_'};
                this.reasons.push(this.otherReason);

                this.stepCancelSelected = false;
            },

            hasReasonSelected: function hasReasonSelected() {
                return !!this._.find(this.reasons, function(reason) { return reason; });
            },

            onNextClick: function onNextClick(step) {
                for ( var key in this.cancellationView) {
                    if (key === step) {
                        this.cancellationView[key] = true;
                    } else {
                        this.cancellationView[key] = false;
                    }
                }

                var reasonForIntercom = this._getCancellationReasonForIntercom();
                if (reasonForIntercom) {

                    switch (step){
                        case 'step_offer':
                        case 'step_feedback':
                            switch (reasonForIntercom.key){
                                case 'missingFeatures':
                                case 'changingPlatform':
                                case 'difficultForMe':
                                case 'difficultForClients':
                                    console.log('Trigger intercom')
                                    this.user.triggerMembershipCancellation(reasonForIntercom.key);
                            }
                            break;
                        default:
                            return false;
                    }
                }

            },

            onKeepPlanClick: function onKeepPlanClick() {
                this.onDismiss && this.onDismiss();
            },

            onCancelPlanClick: function onCancelPlanClick() {
                if (this.duringCancel) {
                    return;
                }

                this.duringCancel = true;

                var reasons = [];

                this._.each(this.reasons, function(reason) {
                   if (reason.selected) {
                       reasons.push(reason.key);
                   }
                }.bind(this));

                this.AccountsManager.cancelPricingPlan(this.user.company.account_id, reasons, '', this.cancelReason).then(function() {
                    this.onCancel && this.onCancel();
                }.bind(this))
                .finally(function() {
                    this.duringCancel = false;
                }.bind(this));
            },

            onPausePlanClick: function onPausePlanClick() {

                this.isPausing = true;

                var reasons = this._.map(this._.filter(this.reasons, function getSelected(reason) {
                    return reason.selected;
                }), function getKeys(reason) {
                    return reason.key;
                });

                this.AccountsManager.pausePricingPlan(this.user.company.account_id, reasons, '', this.cancelReason)
                    .then(function() {
                        angular.isFunction(this.onPause) && this.onPause();
                    }.bind(this))
                    .catch(function(e) {
                        console.log('error', e);
                    })
                    .finally(function() {
                        this.isPausing = false;
                    }.bind(this));
            },

            onReasonChange: function onReasonChange(selectedReason) {
                this._setCancellationSteps(selectedReason);

                // mark all the rest as not selected
                this._.each(this.reasons, function(reason) {
                    if (reason !== selectedReason && reason.selected) {
                        reason.selected = false;
                    }
                }.bind(this));
            },


            _calculatePricingPlan: function _calculatePricingPlan(pricePerDay) {
                if (pricePerDay <= .9){
                    var price = pricePerDay.toString().split(".")[1];
                    return 'For ' + price.length < 2 ? price + ' cents a day... ' : 'For ' + price.substring(0, 2) + ' cents a day... ';
                } else {
                    var priceDecimals = parseFloat(Math.round(pricePerDay * 100) / 100).toFixed(2);
                    return 'For $' + priceDecimals.toString() + ' a day... ';
                }
            },

            _setCancellationSteps: function _setCancellationSteps(selectedReason) {
                this.stepCancelSelected = true;
                this.selectedCancellationReasonText = selectedReason.title;

                this.setCancellationOffer();

                if (selectedReason.key === 'cost') {
                    this.costPerDay = this._calculatePricingPlan(this.pricingPlan.price_per_day);
                }

                switch (selectedReason.key){
                    case 'missingFeatures':
                    case 'changingPlatform':
                    case 'other':
                        this._feedbackRequired(selectedReason);
                        this.nextStepFlow = 'step_feedback';
                        break;
                    case 'transactionFees':
                        this.nextStepFlow = 'step_feedback';
                        break;
                    case 'covid19':
                        this.nextStepFlow = 'step_pause';
                        break;
                    default:
                        this.nextStepFlow = 'step_offer';
                }
            },

            _feedbackRequired: function _feedbackRequired(selectedReason) {
                this.isFeedbackRequired = true;

                switch (selectedReason.key){
                    case 'missingFeatures':
                        this.feedbackQuestion = 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_5._TITLE_';
                        break;
                    case 'changingPlatform':
                        this.feedbackQuestion = 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_6._TITLE_';
                        break;
                    case 'covid19':
                        this.feedbackQuestion = 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_CORONA._TITLE_';
                        break;
                    case 'other':
                        this.feedbackQuestion = 'SETTINGS.SUBSCRIPTION.CANCELLATION.OFFER.CTA_8._TITLE_';
                        break;
                    default:
                        this.feedbackQuestion = 'SETTINGS.SUBSCRIPTION.CANCELLATION.LABELS._HOW_CAN_WE_IMPROVE_';
                }
            },

            setCancellationOffer: function setCancellationOffer() {
                this._.each(this.reasons, function(reason) {
                    if (reason.selected) {
                        switch (reason.key) {

                            case 'difficultForMe':
                                this.suggestionTitle = this.suggestion.difficultForMe.title;
                                this.suggestionSubTitle = this.suggestion.difficultForMe.subTitle;
                                this.suggestionCTA = this.suggestion.difficultForMe.cta;
                                this.suggestionLinkCTA = this.suggestion.difficultForMe.ctaLink;
                                this.suggestionReason = 'cancel-membership__reason--' + reason.key;
                                break;

                            case 'difficultForClients':
                                this.suggestionTitle = this.suggestion.difficultForClients.title;
                                this.suggestionSubTitle = this.suggestion.difficultForClients.subTitle;
                                this.suggestionCTA = this.suggestion.difficultForClients.cta;
                                this.suggestionLinkCTA = this.suggestion.difficultForClients.ctaLink;
                                this.suggestionReason = 'cancel-membership__reason--' + reason.key;
                                break;

                            case 'shuttingDown':
                                this.suggestionTitle = this.suggestion.shuttingDown.title;
                                this.suggestionSubTitle = this.suggestion.shuttingDown.subTitle;
                                this.suggestionCTA = this.suggestion.shuttingDown.cta;
                                this.suggestionLinkCTA = this.suggestion.shuttingDown.ctaLink;
                                this.suggestionReason = 'cancel-membership__reason--' + reason.key;
                                break;

                            case 'cost':
                                this.suggestionTitle = this.suggestion.cost.title;
                                this.suggestionSubTitle = this.suggestion.cost.subTitle;
                                this.suggestionCTA = this.suggestion.cost.cta;
                                this.suggestionLinkCTA = this.suggestion.cost.ctaLink;
                                this.suggestionReason = 'cancel-membership__reason--' + reason.key;
                                break;

                            case 'onlinePayments':
                                this.suggestionTitle = this.suggestion.onlinePayments.title;
                                this.suggestionSubTitle = this.suggestion.onlinePayments.subTitle;
                                this.suggestionCTA = this.suggestion.onlinePayments.cta;
                                this.suggestionLinkCTA = this.suggestion.onlinePayments.ctaLink;
                                this.suggestionReason = 'cancel-membership__reason--' + reason.key;
                                break;
                        }
                    }

                }.bind(this));
            },



            _getCancellationReasonForIntercom: function _getCancellationReasonForIntercom() {
                return this._.find(this.reasons, function(reason) {
                    return reason.selected;
                });
            }
        });

        return {
            restrict: 'E',
            templateUrl: 'angular/app/modules/core/features/settings/company/subscription/cancel_membership/cancel_membership_template.html',
            controller: CancelMembershipDirectiveController,
            controllerAs: 'cancelMembershipVm',
            bindToController: true,
            scope: {
                onDismiss: '&',
                onCancel: '&',
                onPause: '&',
                pricingPlan: '='
            }
        };
    };

}());
